'use client';

import { createContext, useContext, type ReactNode } from 'react';
import getFlatToc from '../_utils/getFlatToc';

import type { FetchDataResult } from '../_fetchData';

type CourseContextValue = {
  canEditCourse: boolean;
  course: FetchDataResult['course'];
  learningOutcomes?: FetchDataResult['learningOutcomes'];
  tableOfContent: FetchDataResult['tableOfContent'];
  flatToc: ReturnType<typeof getFlatToc>;
  recommendedPaths?: FetchDataResult['recommendedPaths'];
  hasActivePathSubscription?: FetchDataResult['hasActivePathSubscription'];
};

const CourseContext = createContext<CourseContextValue | undefined>(undefined);

type Props = {
  children: ReactNode;
  value: CourseContextValue;
};

export const CourseProvider = ({ children, value }: Props) => (
  <CourseContext.Provider value={value}>{children}</CourseContext.Provider>
);

export const useCourseContext = () => {
  const context = useContext(CourseContext);
  if (!context) {
    throw new Error('useCourseContext must be used within a CourseProvider');
  }
  return context;
};
